const state = {
  isMainTableLoading: false,
  isLoading: false,
  currentRoute: {},
  isFormInProgress: false
}

const getters = {
  isMainTableLoading (state) {
    return state.isMainTableLoading // TODO: Remove for vuexy
  },
  isLoading (state) {
    return state.isLoading // TODO: Remove for vuexy
  },
  currentRoute (state) {
    return state.currentRoute
  },
  isFormInProgress (state) {
    return state.isFormInProgress
  }
}

const mutations = {
  SET_IS_MAIN_TABLE_LOADING (state, isMainTableLoading) {
    state.isMainTableLoading = isMainTableLoading
  },
  SET_IS_LOADING (state, isLoading) {
    state.isLoading = isLoading
  },
  SET_CURRENT_ROUTE (state, currentRoute) {
    state.currentRoute = currentRoute
  },
  SET_FORM_INPROGRESS (state, status) {
    state.isFormInProgress = status
  }
}

const actions = {
  setIsMainTableLoading ({ commit }, isMainTableLoading) {
    commit('SET_IS_MAIN_TABLE_LOADING', isMainTableLoading)
  },
  setIsLoading ({ commit }, isLoading) {
    commit('SET_IS_LOADING', isLoading)
  },
  setCurrentRoute ({ commit }, currentRoute) {
    commit('SET_CURRENT_ROUTE', currentRoute)
  },
  setIsFormInProgress ({ commit }, isFormInProgress) {
    commit('SET_FORM_INPROGRESS', isFormInProgress)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
